import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { SystemTransferTypes } from '@/services/systemTransfer/systemTransfer.types';

import { getColumns } from './Column';
import { useDynamicLocale } from '@/hoslog-intl';

export function SystemTransferTable({ data }: { data: SystemTransferTypes[] }) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: t('pointManagement.sidebar.menu.systemTransfer'),
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
